import { List, TextField, useTable } from "@refinedev/antd";
import { useInvalidate } from "@refinedev/core";
import { SyncOutlined } from "@ant-design/icons";
import { Button, Table, Tag, Tooltip, notification } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import axAPI from "../../../api/axios-instance";

interface PushStats {
  id: string;
  source: "cms" | "appmetrica";
  title: string;
  sentTotal: number | null;
  deliveredAndroid: number;
  deliveredIos: number;
  clicksAndroid: number;
  clicksIos: number;
  date: string;
}

export const StatsPushesList = () => {
  const [refreshing, setRefreshing] = useState(false);
  const invalidate = useInvalidate();

  const { tableProps } = useTable<PushStats>({
    dataProviderName: "pushStatsDataProvider",
    resource: "pushlogs",
    syncWithLocation: false,
  });

  const refreshAppmetrica = async () => {
    setRefreshing(true);
    try {
      const { data } = await axAPI.post(
        "/cms/pushlogs/stats/appmetrica/refresh"
      );
      if (data?.error) {
        notification.error({
          message: "AppMetrica не ответила",
          description: data.error,
        });
      } else {
        notification.success({
          message: `Кампании AppMetrica обновлены (${data?.updated ?? 0})`,
        });
        invalidate({
          dataProviderName: "pushStatsDataProvider",
          resource: "pushlogs",
          invalidates: ["list"],
        });
      }
    } catch (e) {
      notification.error({
        message: "Не удалось обновить кампании AppMetrica",
      });
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <List
      title="Статистика пушей"
      canCreate={false}
      breadcrumb={false}
      headerButtons={
        <Tooltip title="Подтянуть внешние кампании из AppMetrica">
          <Button
            icon={<SyncOutlined spin={refreshing} />}
            loading={refreshing}
            onClick={refreshAppmetrica}
          />
        </Tooltip>
      }
    >
      <Table
        {...tableProps}
        rowKey="id"
        scroll={{ x: 1200 }}
        pagination={{
          ...tableProps.pagination,
          pageSizeOptions: [10, 20, 50],
        }}
        locale={{
          emptyText: <div style={{ margin: 56 }}>Пуши отсутствуют</div>,
        }}
      >
        <Table.Column
          dataIndex="title"
          title="Заголовок"
          render={(value, record: PushStats) => (
            <>
              <TextField value={value} />
              {record.source === "appmetrica" && (
                <Tag color="gold" style={{ marginLeft: 8 }}>
                  AppMetrica
                </Tag>
              )}
            </>
          )}
        />

        <Table.Column
          dataIndex="sentTotal"
          title="Отправлено"
          render={(value: number | null) => (value === null ? "—" : value)}
        />

        <Table.Column dataIndex="deliveredAndroid" title="Доставлено Android" />

        <Table.Column dataIndex="deliveredIos" title="Доставлено iOS" />

        <Table.Column dataIndex="clicksAndroid" title="Клики Android" />

        <Table.Column dataIndex="clicksIos" title="Клики iOS" />

        <Table.Column
          dataIndex="date"
          title="Дата"
          render={(value) => dayjs(value).format("DD.MM.YYYY HH:mm")}
        />
      </Table>
    </List>
  );
};
